<template>
  <div class="content">
    <div style="height: 50px;display: flex;align-items: center;">
      <b-input-group>
        <template v-slot:append>
          <b-input-group-text @click="selectchange">
            <img src="../../img/searchImg.png" alt="" srcset="">
          </b-input-group-text>
        </template>
        <b-form-input id="search-input" v-model="localSearchValue" @input="selectchange2"
          style="border-radius: 10px 0 0 10px;" :placeholder="$t('搜尋')"></b-form-input>
      </b-input-group>

    </div>
    <div v-show="resultsData.length == 0" class="googleMap" :id="mapID"
      style="width: 100%; height:calc(100% - 120px);margin-top: 15px;">
    </div>
    <div v-show="resultsData.length > 0" class="searchCss">
      <div class="tabCsss" v-for="item in resultsData" style="" @click="changeitems(item)">
        <div style="width: 40px;height: 40px;padding: 5px;margin-right: 10px;"
          :style="{ backgroundColor: item.icon_background_color }">
          <img style="width: 30px;height: 30px;" :src="item.icon" alt="" />
        </div>
        <div>{{ item.name }}</div>
      </div>
    </div>
    <div style="margin: 10px 0;width: 100%;text-align: right;">
      <!-- <b-button @click="CurrentBtn" variant="primary">{{ $t('当前位置') }}</b-button> -->
      <b-button style="margin-left: 15px;" @click="YESbtn" variant="primary">{{ $t('確認位置') }}</b-button>
    </div>
  </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader' // 引入

export default {
  computed: {
  },
  props: {
    // mapType属性值为:
    // selectPoint时是地图选点
    // POLYGON是绘制地图多边形区域
    // 地图id
    mapID: {
      type: String,
      default: () => {
        return 'googleMap'
      },
    },
    searchValue: {
      type: String,
      default: () => {
        return ''
      },
    },
    // 谷歌地图类型
    mapType: {
      type: String,
      default: () => {
        return 'default'
      },
    },
    // 谷歌地图样式
    googleMapStyle: {
      type: Object,
      default: () => {
        return {
          width: '100%',
          height: '500px',
        }
      },
    },
    // 谷歌地图配置
    mapOptions: {
      type: Object,
      default: () => {
        return {
          // 为了关闭默认控件集, 设置地图的 disableDefaultUI 的属性为 true
          disableDefaultUI: false,
          // 启用缩放和平移
          gestureHandling: 'greedy',
          panControl: true,
          zoomControl: true,
          scaleControl: true,
          // 关闭街景
          streetViewControl: false,
        }
      },
    },
    // 谷歌地图中心点
    googleMapCenter: {
      type: Object,
      default: () => {
        return {
          lat: 25.033,
          lng: 121.565,
        }
      },
    },
    // 谷歌地图缩放级别
    zoom: {
      type: Number,
      default() {
        return 11
      },
    },
    // 谷歌地图图形path
    mapPath: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  data() {
    return {
      // 地图选点回显值
      location: '', // 显示地点名称
      marker: [],
      placesService: null,
      resultsData: [],
      showDropdown: true,
      localSearchValue: this.searchValue,
      Maporientation: null,
      graphicalExample: null,
      graphicalPath: [],
      suggestions: [],
      apiKey: 'AIzaSyDm1RF2oi3fV01beGU5KaIt4Vq4MpIgP6Q',
    }
  },
  // 监听searchValue
  watch: {
    searchValue(val) {
      this.localSearchValue = val;
      // 如果位置清空，重新获取当前位置
      if (val == '') {
        // this.getUserLocation()
      }
      // // 如果位置不为空，搜索位置
      else {
        // this.selectPoint()
      }
    },
  },
  created() {
    this.$nextTick(() => {
      const loader = new Loader({
        apiKey: this.apiKey, // 之前的key
        version: 'weekly', // 版本
        libraries: ['places', 'drawing'], // 插件库
        region: 'TW', // 台湾地区
        language: 'zh-TW', // 台湾中文
      })
      let that = this;
      const mapOptions = {
        center: { lat: 25.033, lng: 121.565 },
        zoom: this.zoom, // 缩放级别
        ...this.mapOptions, // 其他配置
      }
      loader.load().then((google) => {
        const map = new google.maps.Map(document.getElementById(this.mapID), mapOptions);
        this.placesService = new google.maps.places.PlacesService(map);
        this.googleMap = map
        this.googleApi = google
        if (this.googleMapCenter) {
          this.googleMap.setCenter(this.googleMapCenter) // 更新地图中心
          this.addDraggableMarkers(this.googleMapCenter) // 添加标记点
        } else {
          this.getUserLocation()

        }

        // 启用自动完成的搜索框
        // const input = document.getElementById("search-input");
        // 创建自动完成的实例
        // const autocomplete = new google.maps.places.Autocomplete(input);
        // 将自动完成的内容限制为地图显示区域内的地方
        // autocomplete.setBounds(map.getBounds());
        // // 设置选择后的处理函数
        // autocomplete.addListener("place_changed", this.onPlaceChanged);
        // if (this.mapType === 'selectPoint') {
        //   this.selectPoint()
        // }
      })
        .catch((e) => {
          console.log(e)
        })
    })
  },
  methods: {
    onPlaceChanged() {
      // const place = this.autocomplete.getPlace();
      // if (!place.geometry) {
      //   // 用户没有选择任何地方，所以不要做任何事情
      //   return;
      // }
      // // 如果地点有几何位置
      // if (place.geometry.viewport) {
      //   this.googleMap.fitBounds(place.geometry.viewport);
      // } else {
      //   this.googleMap.setCenter(place.geometry.location);
      //   this.googleMap.setZoom(17);
      // }
      // // 设置标记点
      // this.addDraggableMarkers(place.geometry.location);
    },
    changeitems(item) {
      let that = this;
      let location = item.formatted_address.replace(/[\d]{6}/, '')
      location = item.formatted_address.replace(/邮政编码:/, '')
      this.localSearchValue = location;
      const request = {
        query: item.formatted_address,
        fields: ['name', 'geometry', 'formatted_address', 'place_id']
      };
      this.placesService.findPlaceFromQuery(request, function (results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
          const lat = results[0].geometry.location.lat()
          const lng = results[0].geometry.location.lng()
          const googleMapCenter = { lat, lng }
          that.Maporientation = { lat, lng };
          that.googleMap.setCenter(googleMapCenter); // 更新地图中心
          that.addDraggableMarkers(googleMapCenter);
          that.resultsData = [];
        } else {
        }
      });
    },
    addLocationItem(place) {
      let arrData = [];
      arrData.push(place);
      this.suggestions = arrData;
      return;
    },
    CurrentBtn() {
      this.getUserLocation()
    },
    YESbtn() {
      // this.$emit('YESbtn')
      let obj = {
        localSearchValue: this.localSearchValue,
        Maporientation: this.Maporientation
      }
      this.$emit('updateMapvalue', obj) // 将位置传递给父组件
    },
    // 获取当前位置
    getUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude
            const lng = position.coords.longitude
            this.googleMapCenter = { lat, lng };
            this.Maporientation = { lat, lng };
            this.googleMap.setCenter(this.googleMapCenter) // 更新地图中心
            this.addDraggableMarkers(this.googleMapCenter) // 添加标记点
            // new google.maps.Marker({
            //   position: this.googleMapCenter,
            //   map: this.googleMap,
            //   title: '当前位置',
            // })
            // 获取地址并回显到输入框
            const geocoder = new this.googleApi.maps.Geocoder()
            geocoder.geocode({ location: this.googleMapCenter }, (results, status) => {
              if (status === 'OK') {
                if (results[0]) {
                  let location = results[0].formatted_address
                  location = location.replace(/[\d]{6}/, '') // 去掉邮政编码
                  location = location.replace(/邮政编码:/, '') // 清除邮政编码字段
                  this.localSearchValue = location // 更新输入框的值
                  // this.$emit('update:searchValue', location) // 向父组件传递新的值
                }
              } else {
                console.error('Geocoder 请求失败: ' + status)
              }
            })
          },
          (error) => {
            console.error('定位失败', error)
          }
        )
      } else {
        console.error('浏览器不支持获取定位')
      }
    },

    // 回显图形
    echoGraphical() {
      if (this.mapType === 'POLYGON') {
        this.graphicalPath = this.mapPath
        let paths = JSON.parse(this.graphicalPath)
        this.graphicalExample = new this.googleApi.maps.Polygon({
          paths,
          fillColor: 'blue',
          strokeColor: 'blue',
          strokeOpacity: 0.8,
          fillOpacity: 0.4,
          strokeWeight: 5,
          clickable: true,
          editable: true,
          zIndex: 1,
        })
        this.graphicalExample.setMap(this.googleMap)
        this.googleApi.maps.event.addListener(this.graphicalExample.getPath(), 'insert_at', (event) => {
          this.setPath(this.graphicalExample.getPath().Ld)
        })
        this.googleApi.maps.event.addListener(this.graphicalExample.getPath(), 'set_at', (event) => {
          this.setPath(this.graphicalExample.getPath().Ld)
        })
      }
    },

    // path路径emit传出
    setPath(path) {
      this.graphicalPath = []
      if (path.length > 0) {
        path.forEach((v) => {
          this.graphicalPath.push({ lat: v.lat(), lng: v.lng() })
        })
        this.$emit('getGraphicalPath', this.graphicalPath)
      }
    },
    selectchange2() {
      let that = this;
      if (this.localSearchValue) {
        const textSearchRequest = {
          query: this.localSearchValue,
          location: this.googleMapCenter || { lat: 25.033, lng: 121.565 }, // 台北市
          radius: '50000' // 擴大搜尋範圍到50公里
        };
        this.placesService.textSearch(textSearchRequest, function (results, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK && results && results.length > 0) {
            // console.log(results, 1111111111111111111);
            that.resultsData = results;
          } else {
          }
        });
      } else {
        this.resultsData = [];
      }
    },
    // 搜索地点方法
    selectchange() {
      let that = this;
      this.resultsData = [];
      // placesService
      // 使用Places服務搜尋附近的商家/地點
      const request = {
        query: this.localSearchValue,
        fields: ['name', 'geometry', 'formatted_address', 'place_id']
      };
      // 添加搜尋結果
      this.placesService.findPlaceFromQuery(request, function (results, status) {
        console.log(results, status);
        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
          const lat = results[0].geometry.location.lat()
          const lng = results[0].geometry.location.lng()
          const googleMapCenter = { lat, lng }
          that.Maporientation = { lat, lng };
          that.googleMap.setCenter(googleMapCenter); // 更新地图中心
          that.addDraggableMarkers(googleMapCenter);
        } else {
          // 如果Places搜尋失敗，嘗試普通地理編碼
          // geocoder.geocode({ address: query }, function (results, status) {
          //   if (status === "OK" && results[0]) {
          //     this.addDraggableMarkers(results[0].geometry.location);
          //   }
          // });
        }
      });
    },
    selectPoint() {
      const input = this.localSearchValue;
      const searchBox = new this.googleApi.maps.places.SearchBox(input)
      const infoWindow = new this.googleApi.maps.InfoWindow()
      this.googleMap.controls[this.googleApi.maps.ControlPosition.TOP_LEFT].push(input)

      // 点击地图时，通过Geocoder将经纬度转化为地址
      this.googleMap.addListener('click', (e) => {
        // 获取点击位置经纬度
        const lat = e.latLng.lat() // 纬度;
        const lng = e.latLng.lng() // 经度;
        const googleMapCenter = { lat, lng }
        this.Maporientation = { lat, lng };
        this.addDraggableMarkers(googleMapCenter) // 添加标记点
        this.getAddressFromLatLng(e.latLng)
      })

      this.googleMap.addListener('bounds_changed', () => {
        searchBox.setBounds(this.googleMap.getBounds())
      })

      searchBox.addListener('places_changed', () => {
        const places = searchBox.getPlaces()
        if (places.length == 0) return

        let markers = []
        places.forEach((place) => {
          if (!place.geometry || !place.geometry.location) return

          markers.push(
            new this.googleApi.maps.Marker({
              map: this.googleMap,
              title: place.name,
              position: place.geometry.location,
              draggable: false,
            })
          )
          input.value = place.name // 更新输入框为搜索到的第一个地点名称
        })
      })
    },

    // 使用Geocoder将经纬度转换为地址
    getAddressFromLatLng(latLng) {
      const geocoder = new this.googleApi.maps.Geocoder()
      geocoder.geocode({ location: latLng }, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.location = results[0].formatted_address
            this.location = this.location.replace(/[\d]{6}/, '')
            this.location = this.location.replace(/邮政编码:/, '')
            // this.$emit('update:searchValue', this.location) // 将位置传递给父组件
            this.localSearchValue = this.location // 更新输入框为地址

            // document.getElementById('pac-input').value = this.location // 更新输入框为地址
          } else {
            console.error('没有找到地址')
          }
        } else {
          console.error('Geocoder 请求失败: ' + status)
        }
      })
    },


    // 添加标记点
    addDraggableMarkers(googleMapCenter) {
      this.marker.forEach((m) => m.setMap(null))  // 清除所有标记点
      this.marker = []  // 清空标记点数组
      const newMarker = new google.maps.Marker({
        position: googleMapCenter,
        map: this.googleMap,
        title: '当前位置',
      })
      this.marker.push(newMarker)
    },
  },
}
</script>

<style scoped>
.content {
  width: 100%;
  height: 500px;
  position: relative;
}

.controls {
  width: 100%;
  height: 40px;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 999;
  border-radius: 4px;
  padding: 6px;
  border: 1px solid #dcdfe6;
  font-size: 14px;
}

.googleMap {
  width: 100%;
  height: 100%;
}

.searchCss {
  width: 100%;
  height: calc(100% - 120px);
  overflow: auto;
}

.tabCsss {
  display: flex;
  cursor: pointer;
  align-items: center;
  width: 100%;
  padding: 15px 0;
}

.tabCsss:hover {
  background-color: aliceblue;
}
</style>
